import { FC, PropsWithChildren } from "react";
import { Button as BootstrapButton, ButtonProps as BootstrapButtonProps } from "react-bootstrap";
import { TestableOptional } from "./types";
import { ButtonVariant } from "react-bootstrap/types";
import "./Button.css";

type ButtonProps = PropsWithChildren<Omit<BootstrapButtonProps, "variant">> & TestableOptional & ExtendedVariants;
type ExtendedVariants = { variant: ButtonVariant | "cancel" };
export const Button: FC<ButtonProps> = ({ children, testId, ...rest }) => {
  return (
    <BootstrapButton data-testid={`button-${testId}`} {...rest}>
      {children}
    </BootstrapButton>
  );
};
